import countryDb from '@cores/constants/country';
import { DetailServiceSymbol } from '@/services/DetailService';
import { injectService } from '@/inversify.config';
import _ from 'lodash';
import { i18nSymbol } from '@/i18n';
export const name = 'TITLE.render';
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const i18n = injectService(i18nSymbol);
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const { _highlightMixin_hlText } = renderOpts;
    // TODO: BIO_UK这里应该移除了，后面看需不需要加
    const { FAMILY_COUNTRY, PN, PATENT_ID } = row || {};
    const cellValue = _.get(row, prop);
    const hlHtml = {
        innerHTML: _highlightMixin_hlText(cellValue),
    };
    const titleLink = <a class="title-cell-popover" data-link-type={prop} data-link-data={cellValue} data-patent-id={PATENT_ID} data-patent-no={PN} target="_blank" 
    // @ts-ignore
    domProps={hlHtml}></a>;
    let familyCountryLink = null;
    const familyCountry = FAMILY_COUNTRY && PN && !PN.startsWith(FAMILY_COUNTRY) ? FAMILY_COUNTRY : null;
    if (familyCountry) {
        const detailService = injectService(DetailServiceSymbol);
        const familyTag = _.get(detailService, 'setting.family_tag', '');
        let familyType = familyTag.toLowerCase();
        if (familyType === 'docdb')
            familyType = 'simple';
        familyCountryLink = <a data-link-type="patentFamily" data-family-country={familyCountry} data-custom-family-type={familyType} data-patent-no={PN} data-patent-id={PATENT_ID} data-origin-field-name="FAMILY_COUNTRY" class={`ico flag-authority flag-authority--${familyCountry}`} title={i18n.t('app.patentResult.familyTip', {
                country: countryDb[familyCountry.toUpperCase()][i18n.locale],
                familyType: i18n.t(`app.userSetting.${familyTag}`),
            })} target="_blank"></a>;
    }
    return [
        titleLink,
        <div>{familyCountryLink}</div>, // TODO: 这里加个换行，避免99%的专利都看不到小国旗，后面在看怎么显示
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    return row[column.property];
}
export default {
    renderDefault,
    exportMethod,
};
